'use client'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { getEventResultsPublicationStatus } from '@/helpers/event-results'
import { useRouter } from 'next/navigation'
import { useMemo, useState } from 'react'
import StandingsSection from '../../components/standings/standings-section'
import DetailsSection from './details-section'
import DriversSection from './drivers-section'
import EventResultsPublicationNotice from './event-results-publication-notice'
import IracingLeaderboard from './iracing/iracing-leaderboard'
import RulesSection from './rules-section'

export default function SingleEventTabsSection({
  event,
  searchParams,
  params,
  eventDrivers,
  eventDriversLoading,
  selectedSplits,
  setSelectedSplits,
  session,
}) {
  const router = useRouter()
  const [activeTab, setActiveTab] = useState(searchParams.tabName || 'Details')
  const eventSessions = Array.isArray(event?.sessions) ? event.sessions : []
  const publicationStatus = getEventResultsPublicationStatus(eventSessions)
  const hasIRacingTimeAttack = Boolean(
    event?.metadata?.['iracing-time-attack-url'],
  )
  const standingsEvents = useMemo(() => [event], [event])

  const handleTabChange = (value) => {
    setActiveTab(value)
    router.push(
      `/c/${params.communitySlug}/${params.championshipSlug}/${params.eventId}?tabName=${value}`,
      {
        scroll: false,
      },
    )
  }

  return (
    <div className="mt-5 w-full desktop-xs:mt-[36px]">
      <Tabs
        defaultValue="racing"
        className="w-full"
        onValueChange={(value) => handleTabChange(value)}
        value={activeTab}
      >
        <div className="desktop-xs:screen-grid">
          <div className="desktop-xs:grid-indent">
            <TabsList className="no-scrollbar overflow-x-auto overflow-y-hidden">
              <TabsTrigger
                value="Details"
                className="mr-6! px-0! desktop-xs:ml-0! ml-6"
              >
                Details
              </TabsTrigger>
              <TabsTrigger value="Drivers" className="ml-0! mr-6! px-0!">
                Drivers
              </TabsTrigger>
              <TabsTrigger value="Rules" className="ml-0! mr-6! px-0!">
                Rules
              </TabsTrigger>
              <TabsTrigger value="Standings" className="ml-0! mr-6! px-0!">
                Results & Standings
              </TabsTrigger>
            </TabsList>
          </div>
        </div>
        <TabsContent value="Details">
          <DetailsSection
            event={event}
            isSingleEvent={event.championship.isSingleEvent}
            params={params}
          />
        </TabsContent>
        <TabsContent value="Drivers">
          <DriversSection
            eventDrivers={eventDrivers}
            eventDriversLoading={eventDriversLoading}
          />
        </TabsContent>
        <TabsContent value="Rules">
          <RulesSection {...{ params }} />
        </TabsContent>
        <TabsContent value="Standings">
          <div className="screen-grid *:grid-indent">
            {!publicationStatus.hasPublishedResults && hasIRacingTimeAttack ? (
              <IracingLeaderboard
                event={event}
                eventAttendees={eventDrivers || []}
                session={session}
                params={params}
              />
            ) : (
              <>
                <EventResultsPublicationNotice
                  publicationStatus={publicationStatus}
                />
                <StandingsSection
                  championship={event.championship}
                  events={standingsEvents}
                  selectedSplits={selectedSplits}
                  setSelectedSplits={setSelectedSplits}
                  presetEventId={event.id}
                />
              </>
            )}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  )
}
